module.exports = __webpack_public_path__ + "assets/img/sportknowhowxl.31735f25.jpg";